import React from "react";
import { motion } from "framer-motion";

const LOGO_FLAT = "/logo-si.png";

const EASE = [0.22, 1, 0.36, 1];

/**
 * Restrained loading splash (≤ 2.5s):
 *  - Navy backdrop
 *  - Gold monogram fades in (opacity + 8px Y, 1.0s)
 *  - Single gold hairline draws L → R (0.9s)
 *  - Dismisses with upward translate
 */
export const LoadingOverlay = () => {
  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-[#0A1F44] flex items-center justify-center overflow-hidden"
      initial={{ y: 0 }}
      animate={{ y: 0 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.7, ease: EASE }}
      data-testid="loading-overlay"
    >
      <div className="relative flex flex-col items-center w-[80%] max-w-md">
        <motion.img
          src={LOGO_FLAT}
          alt="Samarth Infinity"
          className="h-32 md:h-40 w-auto"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, ease: EASE, delay: 0.15 }}
          draggable="false"
        />
        {/* gold hairline draws L→R */}
        <div className="mt-10 relative h-px w-full bg-white/10">
          <motion.span
            className="absolute inset-y-0 left-0 bg-[#C8961F]"
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.6 }}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default LoadingOverlay;
